module.exports = "/_next/static/images/nyp-9175277d9608b1856d6b9d68a2bd51b3.png";